import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Home from './pages/Home/Home';
import { Metrics } from './pages/Metrics/Metrics';

export const DefaultRoutes = {
  Home: '/',
  Metrics: '/Metrics/:id',
};

const routes = (
  <Switch>
    <Route path={DefaultRoutes.Metrics} component={Metrics} />
    <Route exact path={DefaultRoutes.Home} component={Home} />
    <Redirect to={DefaultRoutes.Home} />
  </Switch>
);

export default routes;
